import {
    createHighlighterCore,
    createJavaScriptRegexEngine,
    type HighlighterCore,
    type LanguageRegistration,
    type ThemeRegistration,
} from "shiki";

let syntaxHighlighter: undefined | Promise<HighlighterCore>;

/**
 * Get the fully prepared syntax highlighter for code highlighting
 */
const getSyntaxHighlighter = async (): Promise<HighlighterCore> => {
    if(typeof syntaxHighlighter !== "undefined") {
        return syntaxHighlighter;
    }

    syntaxHighlighter = createHighlighterCore({
        themes: [
            import("@shikijs/themes/github-dark-dimmed"),
            import("./shopfront-theme.json") as Promise<ThemeRegistration>,
        ],
        langs: [
            import("@shikijs/langs/http"),
            import("@shikijs/langs/javascript"),
            import("@shikijs/langs/bash"),
            import("@shikijs/langs/php"),
            import("@shikijs/langs/jsx"),
            import("@shikijs/langs/json"),
            import("@shikijs/langs/typescript"),
            import("@shikijs/langs/graphql"),
            import("@shikijs/langs/css"),
            import("./shopfront.json") as Promise<LanguageRegistration>,
        ],
        engine: createJavaScriptRegexEngine(),
    });

    return syntaxHighlighter;
};

export { getSyntaxHighlighter };
